'use strict';

var isObject = require('../internals/is-object');

var definePropertyModule = require('../internals/object-define-property');

var getPrototypeOf = require('../internals/object-get-prototype-of');

var HAS_INSTANCE = require('../internals/well-known-symbol')('hasInstance');

var FunctionPrototype = Function.prototype; // `Function.prototype[@@hasInstance]` method
// https://tc39.github.io/ecma262/#sec-function.prototype-@@hasinstance

if (!(HAS_INSTANCE in FunctionPrototype)) {
  definePropertyModule.f(FunctionPrototype, HAS_INSTANCE, {
    value: function value(O) {
      if (typeof this != 'function' || !isObject(O)) return false;
      if (!isObject(this.prototype)) return O instanceof this; // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:

      while (O = getPrototypeOf(O)) {
        if (this.prototype === O) return true;
      }

      return false;
    }
  });
}